export const getImageDimensionsFromFile = ({ file }) =>
  new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
      const width = image.naturalWidth;
      const height = image.naturalHeight;
      URL.revokeObjectURL(objectUrl);
      resolve({ width, height });
    };

    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("invalidImage"));
    };

    image.src = objectUrl;
  });

export const getImageDimensionsFromUrl = ({ url }) =>
  new Promise((resolve, reject) => {
    const imageUrl = String(url || "").trim();
    if (!imageUrl) {
      reject(new Error("invalidImage"));
      return;
    }

    const image = new Image();
    image.onload = () => {
      resolve({
        width: image.naturalWidth,
        height: image.naturalHeight,
      });
    };
    image.onerror = () => {
      reject(new Error("invalidImage"));
    };
    image.src = imageUrl;
  });

export const readImageDimensionsFromUrl = async ({ url }) => {
  try {
    const dimensions = await getImageDimensionsFromUrl({ url });
    const width = Number(dimensions?.width) || 0;
    const height = Number(dimensions?.height) || 0;
    if (width > 0 && height > 0) {
      return { width, height };
    }
  } catch {
    // Keep a 1:1 fallback so import still works if the image cannot be measured.
  }
  return { width: 1, height: 1 };
};
